// extracted by mini-css-extract-plugin
export default {"hidden":"VendorApplicationOnboarding_hidden__VbEYa","loaderContainer":"VendorApplicationOnboarding_loaderContainer__H2zOO"};